import { render, staticRenderFns } from "./ProductWeight.vue?vue&type=template&id=4fdbaeee&scoped=true&"
import script from "./ProductWeight.vue?vue&type=script&lang=js&"
export * from "./ProductWeight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fdbaeee",
  null
  
)

export default component.exports